import Repository from '@/repositories/marketing'
const resource = '/nlp'

export default {
    fetch( data){
        return Repository.post(`${resource}/generate.json`, data)
    },
    storePrompts( data){
        return Repository.post(`${resource}/store_prompts.json`, data)
    },
}
